export default function getThresholdPartial(income, threshold, multiplier) {
	return Math.max(0, Math.min(income, threshold)) * multiplier;
}
